import { http, URL } from "./http.service";
 
 export const passkeyService = {
   generateRegistrationOptions: async (data) => {
     return http.post(URL + "/user/passkey/generate-registration-options", data, {
       headers: { "Content-Type": "application/json" }
     });
   },
   verifyRegistration: async (data) => {
     return http.post(URL + "/user/passkey/verify-registration", data, {
       headers: { "Content-Type": "application/json" }
     });
   },
   generateAuthenticationOptions: async (data) => {
     return http.post(URL + "/user/passkey/generate-authentication-options", data, {
       headers: { "Content-Type": "application/json" }
     });
   },
   verifyAuthentication: async (data) => {
     return http.post(URL + "/user/passkey/verify-authentication", data, {
       headers: { "Content-Type": "application/json" }
     });
   },
 };
